import Immutable from 'immutable';

let componentMap = {};
let modelMap = {};

let _processEntityLink;

export function registerModule(name, component, model) {
	componentMap[name] = component;
	modelMap[name] = model;
}

export function setEntityLinkProcessor(func) {
	_processEntityLink = func;
}

export function processEntityLink(entityName, entityId) {
	if (_processEntityLink) {
		_processEntityLink(entityName, entityId);
	}
}

export function getComponentForModuleId(moduleId) {
	return componentMap[moduleId];
}

export function getComponentForState(state) {
	if (!state) {
		return null;
	}
	return componentMap[state.get('__module')];
}

export function createModelForState(state) {
	if (!state) {
		return null;
	}
	const Model = modelMap[state.get('__module')];
	if (!Model) {
		return null;
	}
	return new Model(state.get('data'));
}

export function createModuleState(moduleName) {
	return Immutable.fromJS({
		__module: moduleName,
		data: {
		}
	});
}
